import { motion } from 'framer-motion';
import { useT } from '../../i18n';

export function LanguageToggle({ compact = false }: { compact?: boolean }) {
  const { lang, setLang } = useT();

  return (
    <div className={`flex items-center gap-0.5 rounded-full bg-ink/6 border border-ink/10 p-0.5 ${compact ? '' : 'p-1'}`} role="group" aria-label={lang === 'en' ? 'Language selector' : 'Språkvelger'}>
      {([
        { value: 'no', flag: '🇳🇴', label: 'NO', ariaLabel: 'Norsk' },
        { value: 'en', flag: '🇬🇧', label: 'EN', ariaLabel: 'English' },
      ] as const).map((opt) => (
        <motion.button
          key={opt.value}
          whileTap={{ scale: 0.94 }}
          onClick={() => setLang(opt.value)}
          aria-label={opt.ariaLabel}
          aria-pressed={lang === opt.value}
          className={[
            'relative flex items-center gap-1.5 rounded-full font-bold text-xs transition-colors',
            compact ? 'px-2.5 py-1' : 'px-3 py-1.5',
            lang === opt.value
              ? 'text-chalk'
              : 'text-ink/50 hover:text-ink/70',
          ].join(' ')}
        >
          {/* Sliding teal pill — animates between the two buttons */}
          {lang === opt.value && (
            <motion.span
              layoutId="lang-active-pill"
              className="absolute inset-0 rounded-full bg-teal shadow-sm"
              transition={{ type: 'spring', stiffness: 500, damping: 35 }}
            />
          )}
          {!compact && (
            <span className="relative z-10 text-base">{opt.flag}</span>
          )}
          <span className="relative z-10">{opt.label}</span>
        </motion.button>
      ))}
    </div>
  );
}
